import React from 'react';
import PropTypes from 'prop-types';

const PlayIcon = ({ className }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${className}`}
      fill="currentColor" // Ensures the color can be changed dynamically
    >
      <path d="M16.1426 10.8482C16.7692 10.4565 16.7692 9.54382 16.1426 9.15215L5.69602 2.62307C5.02997 2.20679 4.16602 2.68563 4.16602 3.47107V16.5292C4.16602 17.3147 5.02997 17.7935 5.69601 17.3772L16.1426 10.8482Z" />
    </svg>
  );
};

PlayIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

PlayIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default PlayIcon;